import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export const SupportButton = () => {
  const { t } = useI18n();
  const [number, setNumber] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/config").then((r) => setNumber(r.data.support_whatsapp || "")).catch(() => {});
  }, []);

  if (!number) return null;
  const link = `https://wa.me/${number}?text=${encodeURIComponent(t("support_prefill"))}`;

  return (
    <div className="fixed bottom-safe right-5 z-[55] no-print flex flex-col items-end gap-3">
      {open && (
        <div className="glass border border-[#2A2A2A] p-5 max-w-[16rem] fade-up" data-testid="support-card">
          <div className="flex items-start justify-between gap-4">
            <p className="eyebrow">{t("support")}</p>
            <button data-testid="support-close-btn" onClick={() => setOpen(false)} className="text-[#707070] hover:text-[#F3F3F1]">
              <X size={15} />
            </button>
          </div>
          <p className="mt-3 text-xs text-[#A8A8A8] leading-relaxed">{t("support_body")}</p>
          <a data-testid="support-whatsapp-link" href={link} target="_blank" rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 bg-[#D4AF37] text-black px-4 py-2.5 text-[10px] tracking-[0.18em] uppercase font-semibold hover:bg-[#E6C96B] transition-colors">
            <MessageCircle size={13} /> {t("chat_whatsapp")}
          </a>
        </div>
      )}
      <button data-testid="support-fab" onClick={() => setOpen((o) => !o)} aria-label={t("support")}
        className="w-13 h-13 p-3.5 bg-[#D4AF37] text-black shadow-lg hover:bg-[#E6C96B] transition-colors rounded-full">
        <MessageCircle size={20} />
      </button>
    </div>
  );
};
